import React from "react";
import { ArrowDownRight, ArrowUpRight, Minus } from "lucide-react";

// Número do período com a variação contra o período anterior de mesmo tamanho
// (a legenda da comparação fica uma vez só, embaixo dos cartões).
export default function Numero({ rotulo, valor, atual, anterior, destaque = false, e2e }) {
  let variacao = null;
  if (anterior > 0) variacao = Math.round(((atual - anterior) / anterior) * 100);
  else if (atual > 0) variacao = "novo";
  const Seta = variacao === "novo" || variacao > 0 ? ArrowUpRight : variacao < 0 ? ArrowDownRight : Minus;
  const cor = variacao === "novo" || variacao > 0 ? "text-emerald-600 dark:text-emerald-400" : variacao < 0 ? "text-red-500" : "text-muted-foreground";
  return (
    <div className={`rounded-xl border p-4 ${destaque ? "bg-emerald-500/10 border-emerald-500/30" : "bg-card"}`} data-e2e={e2e}>
      <p className="text-[11px] uppercase tracking-wide text-muted-foreground">{rotulo}</p>
      <p className="text-2xl font-black tabular-nums mt-0.5">{valor}</p>
      {variacao !== null && (
        <p className={`text-[11px] mt-0.5 flex items-center gap-0.5 ${cor}`}>
          <Seta className="w-3 h-3" />
          {variacao === "novo" ? "novo" : `${variacao > 0 ? "+" : ""}${variacao}%`}
        </p>
      )}
    </div>
  );
}
